import drag from './drag';
// v-click-outside 外部点击指令：当点击非绑定元素会进行元素隐藏
// v-intersect  元素监视器：检测元素在用户视图中是否可见
// v-resize 缩放监听器：窗口进行缩放时的监听指令
// v-scroll 滚动监视器： 可以灵活观察绑定的元素滚动变化
// v-touch 触控监视器：可以灵活监视移动端当中的触摸行为，并产生回调
// v-auth  权限监视器：主要做按钮级别权限校验和页面权限校验

// 自定义指令
// 组件内VNODE更新都会调用update,而非是绑定的div,但只能触发当前组件，不能触发父组件
export default {
  install(Vue) {
    // 弹窗拖拽指令: v-drag-dialog
    Vue.directive('drag-dialog', drag);
    // 自动获取光标指令: v-focus
    Vue.directive('focus', {
      inserted(el) {
        el.focus();
      }
    });
    // 防抖指令
    Vue.directive('throttle', {
      bind: (el, binding) => {
        const throttleTime = binding.value || 2000; // 防抖时间,则默认2s
        let disabled;
        el.addEventListener('click', (ev) => {
          // 第一次执行
          if (!disabled) {
            el.style.pointerEvents = 'none';
            disabled = setTimeout(() => {
              disabled = null;
              el.style.pointerEvents = 'auto';
            }, throttleTime);
          } else if (ev) {
            ev.stopImmediatePropagation();
          }
        }, true);
      }
    });
    // 权限指令
    Vue.directive('auth', {
      inserted: function (el, binding) {
        const arr = ['1', '2', '3', '4'];
        const auth = binding.value; // 获取到v-permission的值
        if (auth) {
          const hasAuth = arr.includes(auth);
          if (!hasAuth && el.parentNode) {
            el.parentNode.removeChild(el); // 没有权限移除Dom元素
          }
        }
      }
    });
    // Vue.directive('fit-columns', {
    //   update() {},
    //   bind() {},
    //   inserted(el) {
    //     setTimeout(() => {
    //       adjustColumnWidth(el);
    //     }, 300);
    //   },
    //   componentUpdated(el) {
    //     el.classList.add('r-table');
    //     setTimeout(() => {
    //       adjustColumnWidth(el);
    //     }, 300);
    //   },
    //   unbind() {},
    // });
  }
};
